var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-dialog",
        {
          attrs: { title: _vm.diaTitle, visible: true, width: "990px" },
          on: { close: _vm.closeDia }
        },
        [
          _c(
            "el-form",
            {
              ref: "roleForm",
              attrs: {
                model: _vm.roleForm,
                rules: _vm.rules,
                "label-width": "120px"
              }
            },
            [
              _c(
                "el-form-item",
                {
                  staticStyle: { "margin-bottom": "18px" },
                  attrs: { label: "权限组名称", prop: "roleName" }
                },
                [
                  _c("el-input", {
                    attrs: {
                      size: "medium",
                      maxLength: "15",
                      readonly:
                        _vm.diaTitle === "权限组详情" ||
                        _vm.diaTitle === "查看权限组",
                      placeholder: "请输入权限组名称"
                    },
                    model: {
                      value: _vm.roleForm.roleName,
                      callback: function($$v) {
                        _vm.$set(_vm.roleForm, "roleName", $$v)
                      },
                      expression: "roleForm.roleName"
                    }
                  })
                ],
                1
              ),
              _c(
                "el-form-item",
                {
                  staticStyle: { "margin-bottom": "18px" },
                  attrs: { label: "权限组描述", prop: "remark" }
                },
                [
                  _c("el-input", {
                    attrs: {
                      type: "textarea",
                      autosize: { minRows: 1, maxRows: 3 },
                      readonly:
                        _vm.diaTitle === "权限组详情" ||
                        _vm.diaTitle === "查看权限组",
                      placeholder: "请输入权限组描述，100字以内"
                    },
                    model: {
                      value: _vm.roleForm.remark,
                      callback: function($$v) {
                        _vm.$set(_vm.roleForm, "remark", $$v)
                      },
                      expression: "roleForm.remark"
                    }
                  })
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "权限组权限", prop: "perms" } },
                [
                  _vm.grant
                    ? _c(
                        "div",
                        { staticClass: "grant-box" },
                        [
                          _c("el-tree", {
                            ref: "permsAuthListRef",
                            attrs: {
                              "show-checkbox": "",
                              "node-key": "pid",
                              "default-expand-all": "",
                              "expand-on-click-node": false,
                              data: !_vm.viewDetail ? _vm.juris : _vm.newJuris,
                              props: _vm.props,
                              "default-checked-keys": _vm.defaultCheckedKeys
                            },
                            on: {
                              check: _vm.checkNode,
                              "check-change": _vm.handleCheckChange
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function(ref) {
                                    var node = ref.node
                                    var data = ref.data
                                    return _c(
                                      "span",
                                      { staticClass: "custom-tree-node" },
                                      [
                                        _c("span", [
                                          _vm._v(_vm._s(node.label))
                                        ]),
                                        data.tips
                                          ? _c(
                                              "span",
                                              [
                                                _c(
                                                  "el-tooltip",
                                                  {
                                                    staticClass: "item",
                                                    attrs: {
                                                      effect: "dark",
                                                      content: data.tips,
                                                      placement: "right"
                                                    }
                                                  },
                                                  [
                                                    _c("i", {
                                                      staticClass: "icon-w1",
                                                      staticStyle: {
                                                        width: "12px",
                                                        height: "12px",
                                                        "margin-left": "5px"
                                                      }
                                                    })
                                                  ]
                                                )
                                              ],
                                              1
                                            )
                                          : _vm._e()
                                      ]
                                    )
                                  }
                                }
                              ],
                              null,
                              false,
                              2921168810
                            )
                          })
                        ],
                        1
                      )
                    : _vm._e()
                ]
              ),
              _vm.organization
                ? _c(
                    "el-form-item",
                    [
                      _c(
                        "template",
                        { slot: "label" },
                        [
                          _vm._v("\n          可授权权限组\n          "),
                          _c(
                            "el-tooltip",
                            {
                              staticClass: "item",
                              attrs: {
                                effect: "dark",
                                content:
                                  "当拥有组织架构管理权限时，可以将以下选中的权限组授权给指定的成员使用",
                                placement: "right"
                              }
                            },
                            [
                              _c("i", {
                                staticClass: "icon-w1",
                                staticStyle: {
                                  width: "12px",
                                  height: "12px",
                                  "margin-left": "5px"
                                }
                              })
                            ]
                          )
                        ],
                        1
                      ),
                      _c("div", { staticClass: "group" }, [
                        _c(
                          "div",
                          { staticClass: "checkbox" },
                          [
                            _c(
                              "el-checkbox",
                              {
                                attrs: {
                                  indeterminate: _vm.isIndeterminate,
                                  disabled: _vm.viewDetail
                                },
                                on: { change: _vm.handleCheckAllChange },
                                model: {
                                  value: _vm.checkAll,
                                  callback: function($$v) {
                                    _vm.checkAll = $$v
                                  },
                                  expression: "checkAll"
                                }
                              },
                              [_vm._v("全选")]
                            ),
                            _c(
                              "el-checkbox-group",
                              {
                                staticStyle: { "margin-left": "18px" },
                                on: { change: _vm.checkedChange },
                                model: {
                                  value: _vm.roles,
                                  callback: function($$v) {
                                    _vm.roles = $$v
                                  },
                                  expression: "roles"
                                }
                              },
                              [
                                _vm._l(_vm.distributeRoles, function(role) {
                                  return _c(
                                    "el-checkbox",
                                    {
                                      key: role.corpRoleId,
                                      attrs: {
                                        label: role.corpRoleId,
                                        disabled: _vm.viewDetail
                                      }
                                    },
                                    [_vm._v(_vm._s(role.roleName))]
                                  )
                                }),
                                _c("br")
                              ],
                              2
                            )
                          ],
                          1
                        )
                      ])
                    ],
                    2
                  )
                : _vm._e()
            ],
            1
          ),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _vm.diaTitle == "角色详情"
                ? _c(
                    "el-button",
                    {
                      attrs: { size: "mini", type: "primary" },
                      on: { click: _vm.closeDia }
                    },
                    [_vm._v("关 闭")]
                  )
                : !_vm.viewDetail
                ? _c(
                    "div",
                    [
                      _c(
                        "el-button",
                        {
                          attrs: { size: "mini" },
                          on: { click: _vm.roleRest }
                        },
                        [_vm._v("重 设")]
                      ),
                      _c(
                        "el-button",
                        {
                          attrs: {
                            size: "mini",
                            type: "primary",
                            loading: _vm.submitLod
                          },
                          on: { click: _vm.roleSubmit }
                        },
                        [_vm._v("提 交")]
                      )
                    ],
                    1
                  )
                : _vm._e()
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-81d6e740", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-81d6e740","hasScoped":true,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./components/console/memberManage/components/rloeFormNew.vue
// module id = QQTS
// module chunks = 7 40